/***
 * @Author: zsh
 * @Date: 2020-05-11 11:44:08
 * @LastEditors: zsh
 * @LastEditTime: 2020-06-28 00:46:13
 * @FilePath: /official-website/src/api/request.js
 **/
"use strict";

import axios from "axios";
import Qs from "qs";

export let fetch = axios.create();

fetch.interceptors.request.use(
  function(config) {
    let language = localStorage.getItem("language") || "zh";
    Object.assign(config.headers, { language, platform: "pc" });

    return {
      ...config,
      headers: {
        ...config.headers
      }
    };
  },
  function(error) {
    return Promise.reject(error);
  }
);

fetch.interceptors.response.use(
  function(response) {
    let res = response.data || {};
    return res;
  },
  function(error) {
    return Promise.reject(error);
  }
);

export function get(url, parm) {
  return new Promise(function(resolve, reject) {
    fetch.get(url, { params: parm }).then(res => {
      resolve(res);
    });
  });
}

export function post(url, parm) {
  return new Promise(function(resolve, reject) {
    fetch({
      url: url,
      data: parm,
      method: "post",
      withCredentials: false,
      headers: {
        "Content-Type": "application/json"
      }
    }).then(res => {
      resolve(res);
    });
  });
}

export function postForm(url, parm) {
  return new Promise(function(resolve, reject) {
    fetch({
      url: url,
      data: Qs.stringify(parm),
      method: "post",
      withCredentials: false,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      }
    }).then(res => {
      resolve(res);
    });
  });
}

export default {
  get,
  post,
  postForm
};



// WEBPACK FOOTER //
// ./src/api/request.js